import React, { Component } from "react"
import { Link } from "react-router-dom"

import TableOfContents from "./TableOfContents.js"
import Simulator from "./Simulator.js"

class Header extends Component {
  render() {
    return (
      <div className="Header">
        <div className="FixedHeader">
          <div className="TitleAndSimulator">
            <Link className="Title HeaderLink" to="/">
              As above so below
            </Link>
            <div className="SimulatorInHeader">
              <Simulator
                patternFn={() => {
                  let currentEntry = this.props.diaries[this.props.current]
                  if (typeof currentEntry === "undefined") {
                    // Empty pattern
                    return 0
                  }

                  return this.props.diaries[this.props.current].patternIndex
                }}
              />
            </div>
            <Link className="Subtitle HeaderLink" to="/">
              Rain diaries
            </Link>
          </div>
          <TableOfContents
            entries={this.props.diaries}
            current={this.props.current}
            onEntryClick={index => {
              this.props.onEntryClick(index)
            }}
          />
          <div style={{ height: "10px" }} />
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js